import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'plainlength',
})
export class PlainLengthPipe implements PipeTransform {
  constructor() {}
  parser = new DOMParser();

  transform(value: any = ''): any {
    return value
      .replace(/<style[^<]+<\/style>/g, '')
      .replace(/<[^>]*>|&nbsp;/g, '')
      .replace(/\s/g, '')
      .length;
  }
}
